"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function get() {
    return _Box["default"];
  }
});
exports["default"] = void 0;
var _Box = _interopRequireDefault(require("./Box"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = _Box["default"];